import React from "react";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import BrFilterTopItemList from '../../components/br/BrFilterTopItemList'
import BrLangFindFilter from '../../components/br/BrLangFindFilter'
import BrBrandHomeListContainer from '../../components/br/BrBrandHomeListContainer'
import BrBrandNoContainer from '../../components/br/BrBrandNoContainer'
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import { brandAction, nobrandAction, setClipBrandIdAction, setNoBrandIdAction } from '../../modules/su/userBrandModule';
import { getBrandInfoAction, setBrandSelFilterIndexAction, setSetBrandFilterDataAction } from '../../modules/common/brandModule';
import { isIE, isChrome, isMobileOnly } from "react-device-detect";


const BrandMainBlock = styled.div`
    ${!isMobileOnly&&"min-width: 1236px"};
`;

const BrandContentsBlock = styled.div`
  ${isMobileOnly?`
       margin: 0 4vw;     
  `:`
      width: 1176px;
      margin: 0 auto;
  `};
    padding-top: 80px
`;

const BrandSectionBlock = styled.div`
    padding: 30px 0 120px;
`;

const BrandSectionWrapBloc = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const BrandTabMarginBloc = styled.div`
    margin-bottom: 30px;
`;


const BrandMain = () => {

    const dispatch = useDispatch();
    const [curTabFirst, setCurTabFirst] = useState(true); //입점브랜드,내가찾는브랜드가 없다면 구분

    const { accessToken, id, brandSelFilterIndex } = useSelector(
        ({ userReducer, brandItemsReducer }) => ({
            accessToken: userReducer.accessToken,
            id: userReducer.id,
            brandSelFilterIndex: brandItemsReducer.brandSelFilterIndex
        })
    );


    //브랜드 좋아요/ 브랜드 요청 데이터 획득
    useEffect(() => {
        if (accessToken !== null) {
            dispatch(brandAction(id));
            dispatch(nobrandAction(id));
        }
        else {
            dispatch(setClipBrandIdAction(null));
            dispatch(setNoBrandIdAction(null));
        }
    }, [accessToken]);

    // 최초 실행시 Header 관련 처리 추가
    useEffect(() => {
        dispatch(setCurMenuAction('br'));
        dispatch(setHeaderTransferAction(false));
        //console.log("BrandMain start");
        window.scrollTo(0, 0);

        // if (isChrome === false || isMobileOnly) {
        //     alert("어디가구는 크롬 PC 화면에 최적화 되어있습니다.")
        // }
        /* if (isIE) {
            alert("어디가구는 크롬 브라우저에 최적화되어 있으며, 인터넷 익스플로러에서는 정상적으로 동작하지 않을 수 있음을 양해 부탁드립니다.")
        } */


    }, [dispatch]);

    useEffect(() => {
        //console.log("curTabFirst " + curTabFirst);
        window.scrollTo(0, 0);
    }, [curTabFirst]);


    const handleClick = (value) => {
        //console.log("handleClick : " + value);

        if (curTabFirst === false && value === true) {
            dispatch(getBrandInfoAction("all", "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "all", type: "0", offset: "0" }));
            dispatch(setBrandSelFilterIndexAction(-1));
        }
        else if (brandSelFilterIndex !== -1 && curTabFirst === true) {
            dispatch(getBrandInfoAction("all", "0", "0"));
            dispatch(setSetBrandFilterDataAction({ data: "all", type: "0", offset: "0" }));
            dispatch(setBrandSelFilterIndexAction(-1));
        }

        setCurTabFirst(value);
        //onOpenModal();

    }

    const onClickAddViewFromTab0 = () => {

    }

    const onClickAddViewFromTab1 = () => {

    }

    return (
        <BrandMainBlock>
            <Header />
            <BrandContentsBlock>
                <BrandSectionBlock>
                    <BrandSectionWrapBloc>
                        <BrandTabMarginBloc>
                            <BrFilterTopItemList onClick={handleClick} curTabFirst={curTabFirst} />
                            <BrLangFindFilter showBlock={curTabFirst ? "block" : "none"} />
                        </BrandTabMarginBloc>

                        {curTabFirst ? <BrBrandHomeListContainer /> : <BrBrandNoContainer />}
                        {/* <BrandTableBloc display = {curTabFirst ? "block" : "none"}>
                            <BrandTableListUlBloc>

                                <BrBrandAndPdList/>
                                <BrBrandAndPdList/>


                            </BrandTableListUlBloc>
                            <BrandAddViewBloc>
                                <BrandAddViewBtnBloc onClick={onClickAddViewFromTab0}>
                                    더보기
                                </BrandAddViewBtnBloc>
                            </BrandAddViewBloc>
                        </BrandTableBloc>
                        <BrandNoContainerBlock display = {curTabFirst ? "none" : "block"}>
                            <BrandNoContainerUlBloc>

                                <BrBrandNoRequestItem key={'fd'} brandname={"까사미아"} requestStatus={0}/>
                                <BrBrandNoRequestItem key={'fdfdf'} brandname={"일룸"} requestStatus={1}/>
                                <BrBrandNoRequestItem key={'fdf3'} brandname={"현대리바트"} requestStatus={2}/>
                            </BrandNoContainerUlBloc>
                            <BrandAddViewBloc>
                                <BrandAddViewBtnBloc onClick={onClickAddViewFromTab0}>
                                    더보기
                                </BrandAddViewBtnBloc>
                            </BrandAddViewBloc>
                        </BrandNoContainerBlock> */}

                    </BrandSectionWrapBloc>
                </BrandSectionBlock>

            </BrandContentsBlock>
            <Footer />
        </BrandMainBlock>
    );
};

export default BrandMain;
